import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLang } from "../lib/LangContext";
import { waLink } from "../lib/mock";
import { FLOATING } from "../constants/testIds";

export const FloatingWhatsApp = () => {
  const { t } = useLang();
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={FLOATING.whatsappBtn}
      aria-label={t.floating.label}
      className="fixed bottom-20 right-5 md:bottom-7 md:right-7 z-50 group"
    >
      <span className="flex items-center gap-3 rounded-full bg-lokam-whatsapp text-white pl-4 pr-5 py-3 md:pl-5 md:pr-6 md:py-4 wa-pulse hover:bg-lokam-whatsapp-dark transition-colors duration-200 shadow-[0_8px_32px_rgba(37,211,102,0.4)]">
        <FaWhatsapp className="h-6 w-6 md:h-7 md:w-7" />
        <span className="text-sm md:text-base font-semibold tracking-tight whitespace-nowrap">
          {t.floating.label}
        </span>
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
